const ViewTechnicianFacilities = () => {
  return (
    <div className="flex flex-col gap-6 m-[6px]">
      <div className="flex flex-col gap-4 border border-[#DCDDE0] rounded-[8px] p-4">
        <p
          className="text-[18px] font-medium text-on-surface-variant"
          aria-label="Obiekty"
          data-testid="view-technician-facilities-title"
        >
          Placówki
        </p>
        <div className="flex flex-col items-center justify-center">
          <p
            className="text-bodyMedium text-on-surface-variant"
            data-testid="view-technician-facilities-empty"
          >
            Brak powiązanych placówek dla tego technika.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ViewTechnicianFacilities;
